export default function () {
  return [
    {
      path: '/ai',
      name: 'Ai',
      component: () => import(/* webpackChunkName: "mine" */ '@views/ai'),
      meta: {
        title: 'Ai',
        needLogin: false
      }
    },
    {
      path: '/aiRecords',
      name: 'AiRecords',
      component: () => import(/* webpackChunkName: "mine" */ '@views/ai/records'),
      meta: {
        title: 'AiRecords',
        needLogin: false
      }
    }
  ];
};
